module.exports = __webpack_public_path__ + "static/img/dd-customer-03.6b1a436.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-customer-03.jpg
// module id = tOWE
// module chunks = 1